// Chakra Imports
import {
  AspectRatio,
  Badge,
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useColorModeValue,
  useDisclosure,
  useToken,
} from "@chakra-ui/react";
// Assets
// import avatar1 from "assets/img/avatars/avatar1.png";
// import avatar2 from "assets/img/avatars/avatar2.png";
// import avatar3 from "assets/img/avatars/avatar3.png";
// Custom Icons

import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Navigate, NavLink, useLocation, useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { useDispatch } from "react-redux";
import { userSignOut } from "appRedux/actions/Auth";
import { isSuccessStatus } from "services/ApiRequest";
import URLs from "constants/URLs";
import { request } from "services/ApiRequest";
import { LogoutIcon } from "components/Icons/Icons";
import { keyframes } from "@emotion/react";
const planStyles = {
  "بدون اشتراک": {
    bg: "plan_none_bg",
    color: "plan_none_color",
    glow: "plan_none_glow",
  },
  آزمایشی: {
    bg: "plan_trial_bg",
    color: "plan_trial_color",
    glow: "plan_trial_glow",
  },
  پلاس: {
    bg: "plan_plus_bg",
    color: "plan_plus_color",
    glow: "plan_plus_glow",
  },
  پرو: {
    bg: "plan_pro_bg",
    color: "plan_pro_color",
    glow: "plan_pro_glow",
  },
};
export default function HeaderLinks(props) {
  const {
    variant,
    children,
    fixed,
    secondary,
    onOpen,
    planName: planNameFromContext,
    ...rest
  } = props;
  const { t } = useTranslation();
  // Chakra Color Mode

  let mainText = useColorModeValue("gray.700", "gray.200");
  let navbarIcon = useColorModeValue("gray.500", "gray.200");

  const [buttonsShadow] = useToken("colors", ["navbar_logout_button_shadow"]);

  const location = useLocation();
const navData = location.state;

const [sherkatShakhs, setSherkatShakhs] = useState(
  navData !== null ? navData.sherkatShakhs : { default: {}, list: [] },
);

const { isOpen, onOpen: onOpenMenu, onClose } = useDisclosure();
const [showLoadingSSH, setShowLoadingSSH] = useState(false);
const [selectedSherkatId, setSelectedSherkatId] = useState(null);

// این بخش باید بعد از تعریف selectedSherkatId باشد
const selectedSherkat =
  sherkatShakhs.list.find((item) => item.id === selectedSherkatId) ||
  sherkatShakhs.default;

const planName =
  planNameFromContext ||
  selectedSherkat?.planName ||
  "بدون اشتراک";

const currentPlan = planStyles[planName] || planStyles["بدون اشتراک"];
const [planGlow] = useToken("colors", [currentPlan.glow]);


  // ------------------- ویدیو آموزشی -------------------

  useEffect(() => {
    const loadSherkatKharidar = async () => {
      setShowLoadingSSH(true);

      const response = await request.GET(URLs.SETTING_GET_ALL_SHERKAT, null);

      if (response && isSuccessStatus(response?.status)) {
        const data = Array.isArray(response.data) ? response.data : [];

        const defaultSherkat =
          data.find((item) => item.id !== null && item.salMali !== null) ??
          data[0] ??
          {};

        setSherkatShakhs({
          default: defaultSherkat,
          list: data,
        });

        setSelectedSherkatId(defaultSherkat.id ?? null);
      }

      setShowLoadingSSH(false);
    };

    if (sherkatShakhs.list.length === 0) {
      loadSherkatKharidar();
    }
  }, []);

  const handleSherkatChange = (selectedCompany) => {
    setSelectedSherkatId(selectedCompany.id);
    onClose();
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();

  if (secondary) {
    navbarIcon = "white";
    mainText = "white";
  }
  const settingsRef = React.useRef();
  const shine = keyframes`
  0% { left: -100%; }
  40% { left: 150%; }
  100% { left: 150%; }
`;

  return (
    <Flex
      position={"sticky"}
      top={0}
      zIndex={999}
      pe={{ sm: "0px", md: "16px" }}
      alignItems="center"
      flexDirection="row"
      py="10px"
      gap={{ base: 4, md: 2 }}
    >
      <Badge
        ml={{base:2,lg:0}}
        bg={currentPlan.bg}
        color={currentPlan.color}
        borderRadius="6px"
        minW={"100px"}
        textAlign={"center"}
        px={{ base: 2, md: 3 }}
        py={1}
        fontSize={{ base: "10px", md: "xs" }}
        fontWeight="bold"
        whiteSpace="nowrap"
        boxShadow={`0 0 12px ${planGlow}`}
      >
        {planName}
      </Badge>
      {/* <InputGroup
        cursor="pointer"
        bg={inputBg}
        borderRadius="15px"
        w={{
          sm: "128px",
          md: "200px",
        }}
        me={{ sm: "auto", md: "20px" }}
        _focus={{
          borderColor: { mainTeal },
        }}
        _active={{
          borderColor: { mainTeal },
        }}
      >
        <InputLeftElement
          children={
            <IconButton
              bg="inherit"
              borderRadius="inherit"
              _hover="none"
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
              }}
              _focus={{
                boxShadow: "none",
              }}
              icon={<SearchIcon color={searchIcon} w="15px" h="15px" />}
            ></IconButton>
          }
        />
        <Input
          fontSize="xs"
          py="11px"
          color={mainText}
          placeholder="Type here..."
          borderRadius="inherit"
        />
      </InputGroup> */}
      {/* <NavLink to="/auth/signin">
        <Button
          ms="0px"
          px="0px"
          me={{ sm: "2px", md: "16px" }}
          color={navbarIcon}
          variant="transparent-with-icon"
          rightIcon={
            document.documentElement.dir ? (
              ""
            ) : (
              <ProfileIcon color={navbarIcon} w="22px" h="22px" me="0px" />
            )
          }
          leftIcon={
            document.documentElement.dir ? (
              <ProfileIcon color={navbarIcon} w="22px" h="22px" me="0px" />
            ) : (
              ""
            )
          }
        >
          <Text display={{ sm: "none", md: "flex" }}>Sign In</Text>
        </Button>
      </NavLink> */}

      {/* <Menu>
        <MenuButton>
          <PersonIcon color={navbarIcon} w="18px" h="18px" />
        </MenuButton>
        <MenuList p="16px 8px">
          <Flex flexDirection="column">
            <MenuItem borderRadius="8px" mb="10px">
              <ItemContent
                time="13 minutes ago"
                info="from Alicia"
                boldInfo="New Message"
                aName="Alicia"
               // aSrc={avatar1}
              />
            </MenuItem>
            <MenuItem borderRadius="8px" mb="10px">
              <ItemContent
                time="2 days ago"
                info="by Josh Henry"
                boldInfo="New Album"
                aName="Josh Henry"
               // aSrc={avatar2}
              />
            </MenuItem>
            <MenuItem borderRadius="8px">
              <ItemContent
                time="3 days ago"
                info="Payment succesfully completed!"
                boldInfo=""
                aName="Kara"
               // aSrc={avatar3}
              />
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu> */}
      {/* -------------------------------------------sherkatshakhs navbar dropdown------------------------------------- */}
      {/* <Menu isOpen={isOpen} onClose={onClose}>
        <MenuButton
          as={Button}
          rightIcon={
            showLoadingSSH ? <Spinner size="sm" /> : <ChevronDownIcon />
          }
          fontSize="sm"
          borderRadius="15px"
          size="md"
          onClick={onOpenMenu}
          textAlign="right"
          pr="20px"
          w="full"
        >
          {sherkatShakhs.list.find((s) => s.id === selectedSherkatId)
            ?.sherkatName ||
            sherkatShakhs.default.sherkatName ||
            "انتخاب شرکت"}
        </MenuButton>

        <MenuList
          maxH="300px"
          minW={20}
          width="fit-content"
          overflowY="auto"
          onMouseEnter={onOpenMenu}
          onMouseLeave={onClose}
        >
          {sherkatShakhs.list.map((item) => {
            const isDefaultCompany = sherkatShakhs.default.id === item.id;

            return (
              <MenuItem
                key={item.id}
                onClick={() => handleSherkatChange(item)}
                bg= "transparent"
                _hover={{ bg: "teal.50" }}
                display="flex"
                justifyContent="start"
                gap={1}
                alignItems="center"
              >
                <Text>{item.sherkatName}</Text>
                {isDefaultCompany && (
                  <Badge
                    colorScheme="teal"
                    variant="subtle"
                    fontSize="9px"
                    px="6px"
                    py="0px"
                    fontWeight={"semibold"}
                    borderRadius="md"
                  >
                    پیش‌فرض
                  </Badge>
                )}
              </MenuItem>
            );
          })}
        </MenuList>
      </Menu> */}
      {/* --------------------------------------------------------------------------------- */}
      {/* <Button
        fontSize={"xs"}
        size={"sm"}
        bg={"button_teal_bg"}
        color={"button_teal_color"}
        borderRadius={"4px"}
        _hover={{ bg: "button_teal_hover" }}
        onClick={() => Navigate("plans")}
      >
        ارتقای اشتراک
      </Button> */}
      {/* <Button
      fontSize={"xs"}
      ml={{base : 3 , md : 0}}
      size={"sm"}
      bg={"button_teal_bg"}
      color={"button_teal_color"}
      borderRadius={"6px"}
      _hover={{ bg: "button_teal_hover" }}
      onClick={() => navigate("/user/plans")}
      position="relative"
      px={{base : 4 , md :10}}
      overflow="hidden"
      sx={{
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: "-100%",
          width: "60%",
          height: "100%",
          background:
            "linear-gradient(120deg, transparent, rgba(255,255,255,0.45), transparent)",
          animation: `${shine} 2s ease-in-out infinite`,
        },
      }}
    >
      ارتقای اشتراک
    </Button> */}

      {/* <Box
        position="relative"
        transition="width .3s"
        w="40px"
        h="40px"
        _hover={{ w: "100px" }}
      >
        <Box
          as={NavLink}
          to="/"
          onClick={handleSignOut}
          position="absolute"
          top={0}
          left={0}
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          overflow="hidden"
          bg="navbar_logout_button_bg"
          borderRadius="6px"
          boxShadow={buttonsShadow}
          h="40px"
          w="40px"
          pr={3}
          pl={1}
          ml={{ base: 2, md: 0 }}
          transition="width .3s ease"
          _hover={{
            w: "100px",
          }}
          sx={{
            "&:hover .logout-label": {
              opacity: 1,
              maxWidth: "60px",
              marginRight: "8px",
            },
          }}
        >
          <Box flexShrink={0}>
            <LogoutIcon color="navbar_logout_button_icon" />
          </Box>

          <Text
            className="logout-label"
            whiteSpace="nowrap"
            overflow="hidden"
            maxWidth="0"
            opacity={0}
            marginRight="0"
            transition="all .3s ease"
            fontSize="sm"
            color="navbar_logout_button_color"
          >
            خروج
          </Text>
        </Box>
      </Box> */}
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};